import { PureComponent } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Paths } from "../../constants/UrlConstants";

const excludedPaths = [Paths.InboxLoader];

export function mapStateToGoogleTagManagerDataLayer(state) {
  let policy =
    state && state.policyReducer && state.policyReducer.selectedPolicy;
  return {
    loggedIn: state && state.accountReducer && state.accountReducer.isLoggedIn,
    membershipNumber: policy && policy.MembershipNumber,
    audience:
      policy &&
      (policy.IsInternational
        ? "international"
        : policy.IsSaga
        ? "saga"
        : policy.IsLargeCorporate
        ? "corporate"
        : policy.IsSME
        ? "smallbusiness"
        : policy.IsIndividual
        ? "individual"
        : undefined)
  };
}

export class GoogleTagManagerDataLayer extends PureComponent {
  componentDidUpdate(prevProps) {
    if (
      this.props.location &&
      this.props.location.pathname !== prevProps.location.pathname &&
      excludedPaths.indexOf(this.props.location.pathname) === -1
    ) {
      if(prevProps.pageType!=="login" && this.props.pageName.includes("Home") ){
        window.dataLayer &&
        window.dataLayer.push({
          event: "virtual_pageview",
          page_name: this.props.pageName
        });
      }
      else if(!this.props.pageName.includes("Home"))
      {
        window.dataLayer &&
        window.dataLayer.push({
          event: "virtual_pageview",
          page_name: this.props.pageName
        });
      }
      
    }
    else if(this.props.location.pathname === "/" && this.props.membershipNumber !==null 
      && this.props.membershipNumber !== undefined
    && this.props.membershipNumber !== prevProps.membershipNumber)
      {
        window.dataLayer &&
        window.dataLayer.push({
          event: "virtual_pageview",
          page_name: this.props.pageName
        });
      }
  }

  render() {
    const props = this.props;
    var pageTypeExist=false;
    let obj = {
      page_type: props.pageType,
      page_product: props.pageProduct,
      page_name: props.pageName,
      user_logged_in: props.loggedIn ? "true" : "false",
      userid: props.membershipNumber == null ? undefined: props.membershipNumber,
      audience: props.audience == null ? undefined : props.audience
    };
    if(obj.page_type === "homepage" && props.location.pathname === "/")
    {
      if(obj.userid !== undefined && obj.user_logged_in)
      {
        window.dataLayer.forEach(element => {
          if(element.page_type === "homepage")
          {
            pageTypeExist=true;
          }
        });
        if(!pageTypeExist)
        {
          window.dataLayer && window.dataLayer.push(obj);
        }
        else if (pageTypeExist && window.dataLayer.length>10)
        {
          window.dataLayer && window.dataLayer.push(obj);
        }
        
      }
    }
    else if(obj.page_type !== "login"){
      window.dataLayer && window.dataLayer.push(obj);
    }
    return null;
  }
}

export default withRouter(
  connect(mapStateToGoogleTagManagerDataLayer)(GoogleTagManagerDataLayer)
);
